var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.79289 5.30241C9.18342 4.91189 9.81658 4.91189 10.2071 5.30241L16.2071 11.3024C16.5976 11.6929 16.5976 12.3261 16.2071 12.7166L10.2071 18.7166C9.81658 19.1072 9.18342 19.1072 8.79289 18.7166C8.40237 18.3261 8.40237 17.6929 8.79289 17.3024L14.0858 12.0095L8.79289 6.71663C8.40237 6.3261 8.40237 5.69294 8.79289 5.30241Z",
    fill: "#FF9900"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevron-right.d02d5adadb424011f4ae20e96905ffb4.svg";
export { ForwardRef as ReactComponent };